const features = [
  {
    icon: 'ri-shield-keyhole-line',
    title: 'Advanced Encryption',
    desc: '256-bit AES encryption ensures your data remains completely private and inaccessible to third parties on any network.',
  },
  {
    icon: 'ri-speed-line',
    title: 'Optimized Performance',
    desc: 'Lightweight architecture designed specifically for iOS, delivering blazing-fast speeds without draining your battery.',
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'User-Friendly Interface',
    desc: 'Intuitive, clean design that follows Apple\'s Human Interface Guidelines — powerful features made effortlessly simple.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Regular Updates',
    desc: 'Continuous improvements and security patches delivered automatically, keeping you protected against the latest threats.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '24/7 Support',
    desc: 'Our dedicated support team is always available to help you get the most out of your KONUS applications.',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Privacy Protection',
    desc: 'Strict zero-log policy and no data collection — your online activity stays yours, always and without exception.',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-24 md:py-32 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16 md:mb-20">
          <p className="text-xs uppercase tracking-[0.2em] text-teal-600 font-semibold mb-4">
            Why Choose Us
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Built for Excellence
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
            Every feature is thoughtfully crafted to deliver the best possible experience on iOS devices.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-white rounded-2xl p-7 md:p-8 hover:shadow-md transition-shadow duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-teal-50 mb-5 group-hover:bg-teal-100 transition-colors duration-300">
                <i className={`${f.icon} text-teal-600 text-2xl`} />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">{f.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
